import fun from "../../../util/util";
import myConst from "@/util/my-const";
import Router from "../../../router"
export default {
    namespaced:true,
    state:{
        energyStorageSysMenu:"", //储能系统的菜单
        menuId:"", //储能系统切换的菜单id
    },
    mutations:{
         
        //设置储能系统的菜单
        setEnergyStorageSysMenu(state,menu){
            if(menu && menu.length > 0 ){
                state.energyStorageSysMenu = menu
                let arr = menu.filter(item=>{
                    return item.menuType == myConst.menuType.menu
                })
                if(arr.length > 0){
                    Router.push({path:menu[0].routerPath})
                    state.menuId = arr[0].menuCode
                }
              
                 
                sessionStorage.setItem(myConst.keyEnergyStorageSysMenuList, JSON.stringify(menu));
            }
            
        },

        
        //设置储能系统菜单id
        setMenuId(state,id){
            state.menuId = id
        },
        
        clearEneryMenu(state){
            sessionStorage.removeItem(myConst.keyEnergyStorageSysMenuList);
            state.energyStorageSysMenu = ""
            state.menuId = ""
        }

    },
    getters:{
         //获取储能系统的菜单数据
        getEnergyStorageSysMenu(state){
            state.energyStorageSysMenu = JSON.parse(sessionStorage.getItem(myConst.keyEnergyStorageSysMenuList));
            return  state.energyStorageSysMenu
        }, 
    }

}